export const skillsLists =[
    {
        "value": "react"
    },
    {
        "value": "web3"
    },
    {
        "value": "node"
    },
    {
        "value": "JavaScript"
    },
    {
        "value": "CSS"
    },
    {
        "value": "HTML"
    },
    {
        "value": "VUE"
    },
    {
        "value": "VUE JS"
    },
    {
        "value": "angular"
    },
    {
        "value": "angular js"
    },
    {
        "value": "Java"
    },
    {
        "value": "JQuery"
    },
    {
        "value": "Python"
    },
    {
        "value": "DJango"
    },
    {
        "value": ".net"
    },
    {
        "value": "Unity Developer"
    },
    {
        "value": "ASO"
    },
    {
        "value": "SEO"
    },
    {
        "value": "C++"
    },
    {
        "value": "C#"
    },
    {
        "value": "OOP"
    },
    {
        "value": "MYSQL"
    },
    {
        "value": "PostgreSQL"
    },
    {
        "value": "SQL"
    },
    {
        "value": "IOT"
    },
    {
        "value": "Ruby"
    },
    {
        "value": "Ruby on Rails"
    },
    {
        "value": "PHP"
    },
    {
        "value": "laravel"
    },
    {
        "value": "problem solving"
    },
    {
        "value": "git"
    },
    {
        "value": "github"
    },
    {
        "value": "json"
    },
    {
        "value": "wordpress"
    },
    {
        "value": "andriod"
    },
    {
        "value": "xml"
    },
    
    {
        "value": "restfull architechture"
    },
    
    {
        "value": "J2EE Technologies"
    },
    {
        "value": "frontend"
    },
    
    {
        "value": "SASS"
    },
    {
        "value": "Project Managment"
    },
    
    {
        "value": "QA"
    },
    {
        "value": "Microsoft SQL"
    },
    {
        "value": "azure"
    },

    {
        "value": "linux"
    },
    {
        "value": "CLI"
    },
    {
        "value": "REST API"
    },
    
    {
        "value": "oracle"
    },
    {
        "value": "web API"
    },
    {
        "value": "MVC Architecture"
    },
    {
        "value": "TypeScript"
    },
    {
        "value": "MongoDB"
    },
    {
        "value": "ASP.net"
    },
    {
        "value": "GO"
    },
    {
        "value": "R"
    },
    {
        "value": "matlab"
    },
    {
        "value": "dataScience"
    },
    {
        "value": "react native"
    },
    {
        "value": "AWS"
    },
    {
        "value": "cloud architecture"
    },
    {
        "value": "APIs"
    },
    {
        "value": "redux"
    },
    {
        "value": "node js"
    },
    {
        "value": "node.js"
    },
    {
        "value": "Flutter"
    },
    {
        "value": "Android"
    },
    {
        "value": "iOS"
    },
    {
        "value": "Express JS"
    },
    {
        "value": "Apex"
    },
    {
        "value": "Apache"
    },
    {
        "value": "Apache Tomcat"
    },
    {
        "value": "GraphQL"
    },
    {
        "value": "Google APIs"
    },
    {
        "value": "Next.js"
    },
    {
        "value": "Next Js"
    },
    {
        "value": "HTML5"
    },
    {
        "value": "CSS3"
    },
    {
        "value": "SQLite"
    },
    {
        "value": "MSSQL"
    },
    {
        "value": "Redis"
    },
    {
        "value": "Microsoft Dynamics 365"
    },
    {
        "value": "Dynamics AX"
    },
    {
        "value": "SAP FI/CO"
    },
    {
        "value": "SAP BW (Business Warehouse)"
    },
    {
        "value": "Diamant"
    },
    {
        "value": "Aareon Wodis"
    },
    {
        "value": "Excel"
    },
    {
        "value": "Pivot"
    },
    {
        "value": "Access"
    },
    {
        "value": "Unity 3D"
    },
    {
        "value": "Perl"
    },
    {
        "value": "Objective-C"
    },
    {
        "value": "Keras"
    },
    {
        "value": "TensorFlow"
    },
    {
        "value": "Scipy"
    },
    {
        "value": "Scikit-learn"
    },
    {
        "value": "OpenCV"
    },
    {
        "value": "CUDA"
    },
    {
        "value": "Firebase"
    },
    {
        "value": "Realm"
    },
    {
        "value": "ES6 PHP"
    },
    {
        "value": "Rabbit"
    },
    {
        "value": "MQ Docker"
    },
    {
        "value": "JEST"
    },
    {
        "value": "CI/CD Tools"
    },
    {
        "value": "Golang"
    },
    {
        "value": "SalesForce"
    },
    {
        "value": "SharePoint"
    },
    {
        "value": "Hibernate"
    },
    {
        "value": "Scrum"
    },
    {
        "value": "PMP"
    },
    {
        "value": "ITIL"
    },
    {
        "value": "DynamoDB"
    },
    {
        "value": "microservices"
    },
    {
        "value": "Kotlin"
    },
    {
        "value": ".net core"
    },
    {
        "value": "MERN"
    },
    {
        "value": "MEAN"
    },
    {
        "value": "HP ALM"
    },
    {
        "value": "HL7"
    },
    {
        "value": "Manual Testing"
    },
    {
        "value": "QA Automation"
    },
    {
        "value": "Selenium"
    },
    {
        "value": "DevOps"
    },
    {
        "value": "TFS"
    },
    {
        "value": "Kanban"
    },
    {
        "value": "Front end Unity"
    },
    {
        "value": "GamePlay"
    },
    {
        "value": "Jenkins"
    },
    {
        "value": "GCP"
    },
    {
        "value": "Redhat"
    },
    {
        "value": "Ubuntu"
    },
    {
        "value": "Docker"
    },
    {
        "value": "Terraform"
    },
    {
        "value": "ARM"
    },
    {
        "value": "ElasticSearch"
    },
    {
        "value": "RedShift"
    },
    {
        "value": "TeraData"
    },
    {
        "value": "Flask"
    },
    {
        "value": "Beego"
    },
    {
        "value": "Gin"
    },
    {
        "value": "Mux"
    },
    {
        "value": "Kafka"
    },
    {
        "value": "TDD"
    },
    {
        "value": "Andriod Canvas"
    },
    {
        "value": "Andriod Security"
    },
    {
        "value": "Kubernetes"
    },
    {
        "value": "Gorrila"
    },
    {
        "value": "Thymeleaf"
    },
    {
        "value": "a"
    },
    {
        "value": "Spring MVC"
    },
    {
        "value": "Spring ORM"
    },
    {
        "value": "Open Shift"
    },
    {
        "value": "ICP"
    },
    {
        "value": "Scrappy"
    },
    {
        "value": "Ethereum Virtual Machine"
    },
    {
        "value": "HyperLedger"
    },
    {
        "value": "Solidity"
    },
    {
        "value": "Gananche"
    },
    {
        "value": "Ethereum"
    },
    {
        "value": "Smart Contactsl"
    },
    {
        "value": "cronos"
    },
    {
        "value": "Polygon"
    },
    {
        "value": "Cosmos SDK"
    },
    {
        "value": "BlockChain"
    },
    {
        "value": "EthPM"
    },
    {
        "value": "Dapps"
    },
    {
        "value": "Ether js"
    },
    {
        "value": "Web3 js"
    },
    {
        "value": "Magento"
    },
    {
        "value": "Ajax"
    },
    {
        "value": "Magento Backend"
    },
    {
        "value": "CyPress"
    },
    {
        "value": "Appium"
    },
    {
        "value": "Automation Testing"
    },
    {
        "value": "Unit testing"
    },
    {
        "value": "TestNG"
    }
]